import React from "react";
import "../template-file-css/document-file-template.css";
import { TrackChangesOutlined } from "@mui/icons-material";

export const NP_SubstanceAbuseAssesment = ({ itemsRef, showErrorFor }) => {
  return (
    <form id="NP_SubstanceAbuseAssesment" className="file-pdf-document">
      <div className="file-template">


        <p className='w-750'>
          <center>
            <h2>SUBSTANCE ABUSE COMPREHENSIVE ASSESSMENT </h2></center>
        </p>


        <h4>A. ASSESSMENT INFORMATION (COMPLETE ALL INFORMATION)</h4>
        <table>
          <tr>
            <td className="w-250">
              <span className="eleHeader">Individual Name:</span>
            </td>
            <td className="w-250">
              <span className="eleHeader">Assessment Date:</span>
            </td>
            <td className="w-250">
              <span className="eleHeader">Assessor Name:</span>
            </td>
          </tr>
          <tr>
            <td className="w-250">
              <input
                type="text"
                id="txtIndividualName"
                name="txtIndividualName"
                className="add-only"
              />
            </td>
            <td className="w-250">
              <input
                type="date"
                id="dtAssessmentDate"
                name="dtAssessmentDate"
                className="add-only"
              />
            </td>
            <td className="w-250">
              <input
                type="text"
                id="txtAssessorName"
                name="txtAssessorName"
                className="add-only"
              />
            </td>
          </tr>
        </table>

        <table>
          <tr>
            <td className="w-250">
              <span className="eleHeader">Parent/Guardian:</span>
            </td>
            <td className="w-250">
              <span className="eleHeader">Home Telephone:</span>
            </td>
            <td className="w-250">
              <span className="eleHeader">Cell phone:</span>
            </td>
          </tr>
          <tr>
            <td className="w-250">
              <input
                type="text"
                id="txtParentGuardian"
                name="txtParentGuardian"
                className="add-only"
              />
            </td>
            <td className="w-250">
              <input
                type="text"
                id="txtHomeTelephone"
                name="txtHomeTelephone"
                className="add-only"
              />
            </td>
            <td className="w-250">
              <input
                type="text"
                id="txtCellPhone"
                name="txtCellPhone"
                className="add-only"
              />
            </td>
          </tr>
        </table>

        <table>
          <tr>
            <td className="w-250">
              <span className="eleHeader">Address:</span>
            </td>
            <td className="w-250">
              <span className="eleHeader">City:</span>
            </td>
            <td className="w-250">
              <span className="eleHeader"> State:</span>
            </td>
          </tr>
          <tr>
            <td className="w-250">
              <input
                type="text"
                id="txtAddress"
                name="txtAddress"
                className="add-only"
              />
            </td>
            <td className="w-250">
              <input
                type="text"
                id="txtCity"
                name="txtCity"
                className="add-only"
              />
            </td>
            <td className="w-250">
              <input
                type="date"
                id="txtState"
                name="txtState"
                className="add-only"
              />
            </td>
          </tr>
        </table>

        <table>
          <tr>
            <td className="w-250">
              <span className="eleHeader">Zip code</span>
            </td>
            <td className="w-250">
              <span className="eleHeader">Individual DOB:</span>
            </td>
            <td className="w-250">
              <span className="eleHeader">Age</span>
            </td>
          </tr>
          <tr>
            <td className="w-250">
              <input
                type="text"
                id="txtZipCode"
                name="txtZipCode"
                className="add-only"
              />
            </td>
            <td className="w-250">
              <input
                type="date"
                id="txtIndividualDob"
                name="txtIndividualDob"
                className="add-only"
              />
            </td>
            <td className="w-250">
              <input
                type="text"
                id="txtAge"
                name="txtAge"
                className="add-only"
              />
            </td>
          </tr>
        </table>

        <table>
          <tr>
            <td className="w-375">
              <span className="eleHeader">Race/Ethnicity</span>
            </td>
            <td className="w-375">
              <span className="eleHeader">Sex assigned at birth:</span>
            </td>
          </tr>
          <tr>
            <td className="w-375">
              <input
                type="text"
                id="txtRaceEthnicity"
                name="txtRaceEthnicity"
                className="add-only"
              />
            </td>
            <td className="w-375">
              <input
                type="radio"
                id="rbSexAtBirth_Yes"
                name="rbSexAtBirth"
                className="add-only"
                value="0"
              />
              Male &nbsp;
              <input
                type="radio"
                id="rbSexAtBirth_No"
                name="rbSexAtBirth"
                className="add-only"
                value="1"
              />
              Female &nbsp;
              <input
                type="radio"
                id="rbSexAtBirth_Other"
                name="rbSexAtBirth"
                className="add-only"
                value="2"
              />
              Intersex
            </td>
          </tr>
        </table>

        <table>
          <tr>
            <td className="w-750">
              <span className="eleHeader">What is your gender?</span>
            </td>
          </tr>
          <tr>
            <td className="w-500">
              <input
                type="radio"
                id="rbGender_Yes"
                name="Gender"
                className="add-only"
                value="0"
              />
              Male &nbsp;
              <input
                type="radio"
                id="rbGender_No"
                name="Gender"
                className="add-only"
                value="1"
              />
              Female &nbsp;
              <input
                type="radio"
                id="rbGender_Other1"
                name="Gender"
                className="add-only"
                value="2"
              />
              Non-binary/ third gender &nbsp;
              <input
                type="radio"
                id="rbGende_Other2"
                name="Gender"
                className="add-only"
                value="3"
              />
              Prefer to self-describe
            </td>
            <td>
              <input
                type="text"
                id="txt_rbSexAtBirth_Other2"
                name="txt_rbSexAtBirth_Other2"
                className="add-only"
              />
            </td>
          </tr>
        </table>

        <table>
          <tr>
            <td className="w-250">
              <span className="eleHeader">Emergency Contact Name:</span>
            </td>
            <td className="w-250">
              <span className="eleHeader">Relationship</span>
            </td>
            <td className="w-250">
              <span className="eleHeader">Contact Telephone</span>
            </td>
          </tr>
          <tr>
            <td className="w-250">
              <input
                type="text"
                id="txtEmergencyContact"
                name="txtEmergencyContact"
                className="add-only"
              />
            </td>
            <td className="w-250">
              <input
                type="text"
                id="txtRelationship"
                name="txtRelationship"
                className="add-only"
              />
            </td>
            <td className="w-250">
              <input
                type="text"
                id="txtContactTelephone"
                name="txtContactTelephone"
                className="add-only"
              />
            </td>
          </tr>
        </table>

        <p>
          <strong>INSURANCE INFORMATION</strong>
        </p>
        <table>
          <tr>
            <td className="w-750">
              <span className="eleHeader">Insurance Type</span>
            </td>
          </tr>
          <tr>
            <td className="w-375">
              <input
                type="checkbox"
                id="cbInsuranceType_1"
                name="cbInsuranceType_1"
                className="add-only"
                value="InsuranceType_1"
              />
              Medicaid Standard:
              <input
                type="text"
                id="txtMedicaid1"
                name="txtMedicaid1"
                className="add-only"
              />
            </td>
            <td className="w-375">
              <input
                type="checkbox"
                id="cbInsuranceType_2"
                name="cbInsuranceType_2"
                className="add-only"
                value="InsuranceType_2"
              />
              Cenpatico::
              <input
                type="text"
                id="txtMedicaid2"
                name="txtMedicaid2"
                className="add-only"
              />
            </td>
          </tr>
          <tr>
            <td className="w-375">
              <input
                type="checkbox"
                id="cbInsuranceType_3"
                name="cbInsuranceType_3"
                className="add-only"
                value="InsuranceType_3"
              />
              Amerigroup:
              <input
                type="text"
                id="txtMedicaid3"
                name="txtMedicaid3"
                className="add-only"
              />
            </td>
            <td className="w-375">
              <input
                type="checkbox"
                id="cbInsuranceType_4"
                name="cbInsuranceType_4"
                className="add-only"
                value="InsuranceType_4"
              />
              Wellcare:
              <input
                type="text"
                id="txtMedicaid4"
                name="txtMedicaid4"
                className="add-only"
              />
            </td>
          </tr>

          <tr>
            <td className="w-375">
              <input
                type="checkbox"
                id="cbInsuranceType_5"
                name="cbInsuranceType_5"
                className="add-only"
                value="InsuranceType_5"
              />
              Caresource:
              <input
                type="text"
                id="txtMedicaid5"
                name="txtMedicaid5"
                className="add-only"
              />
            </td>
            <td className="w-375">
              <input
                type="checkbox"
                id="cbInsuranceType_6"
                name="cbInsuranceType_6"
                className="add-only"
                value="InsuranceType_6"
              />
              Other:
              <input
                type="text"
                id="txtMedicaid6"
                name="txtMedicaid6"
                className="add-only"
              />
            </td>
          </tr>
        </table>

        <h3>B. INDIVIDUAL PRESENTATION & PRESENTING PROBLEM</h3>
        <p>
          <span className="eleHeader">Location of assessment?</span>
          <textarea
            id="txtLocationAssessment"
            name="txtLocationAssessment"
            className="add-only"
          ></textarea>
        </p>

        <p>
          <span className="eleHeader">Who was present during assessment?</span>
          <textarea
            id="txtPresentAssessment"
            name="txtPresentAssessment"
            className="add-only"
          ></textarea>
        </p>

        <p>
          <span className="eleHeader">PRESENTING SITUATION:</span>
          <textarea
            id="txtPRESENTING_SITUATION"
            name="txtPRESENTING_SITUATION"
            className="add-only"
          ></textarea>
        </p>

        <p>
          <span className="eleHeader">MEDICAL STATUS:</span>
          <textarea
            id="txtMEDICAL_STATUS"
            name="txtMEDICAL_STATUS"
            className="add-only"
          ></textarea>
        </p>

        <p>
          <span className="eleHeader">DRUG/ALCOHOL USE:</span>
          <textarea
            id="txt_DRUG_ALCOHOL_USE"
            name="txt_DRUG_ALCOHOL_USE"
            className="add-only"
          ></textarea>
        </p>

        <h3> SUBSTANCE ABUSE INFORMATION</h3>
        <table>
          <tr>
            <td className="w-150">
              <span className="eleHeader">Substance Name</span>
            </td>
            <td className="w-150">
              <span className="eleHeader">
                Age of 1<sup>st</sup> Use
              </span>{" "}
              <span className="small"> Must Complete </span>{" "}
            </td>
            <td className="w-150">
              <span className="eleHeader">Age of Heaviest Use</span>
            </td>
            <td className="w-150">
              <span className="eleHeader">Frequency/Amount</span>
            </td>
            <td className="w-150">
              <span className="eleHeader">Date of Last use</span>
            </td>
          </tr>
          <tr>
            <td className="w-150">Alcohol</td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeFirstUse_1"
                name="txtAgeFirstUse_1"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeHeaviestUse_1"
                name="txtAgeHeaviestUse_1"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAmount_1"
                name="txtAmount_1"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="date"
                id="txtLastuse_1"
                name="txtLastuse_1"
                className="add-only"
              />
            </td>
          </tr>
          <tr>
            <td className="w-150">Cannabis</td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeFirstUse_2"
                name="txtAgeFirstUse_2"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeHeaviestUse_2"
                name="txtAgeHeaviestUse_2"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAmount_2"
                name="txtAmount_2"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="date"
                id="txtLastuse_2"
                name="txtLastuse_2"
                className="add-only"
              />
            </td>
          </tr>
          <tr>
            <td className="w-150">Cocaine</td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeFirstUse_3"
                name="txtAgeFirstUse_3"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeHeaviestUse_3"
                name="txtAgeHeaviestUse_3"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAmount_3"
                name="txtAmount_3"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="date"
                id="txtLastuse_3"
                name="txtLastuse_3"
                className="add-only"
              />
            </td>
          </tr>
          <tr>
            <td className="w-150">
              Stimulants
              <span className="small">(Crystal, speed, amphetamines)</span>
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeFirstUse_4"
                name="txtAgeFirstUse_4"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeHeaviestUse_4"
                name="txtAgeHeaviestUse_4"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAmount_4"
                name="txtAmount_4"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="date"
                id="txtLastuse_4"
                name="txtLastuse_4"
                className="add-only"
              />
            </td>
          </tr>
          <tr>
            <td className="w-150">Methamphetamine</td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeFirstUse_5"
                name="txtAgeFirstUse_5"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeHeaviestUse_5"
                name="txtAgeHeaviestUse_5"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAmount_5"
                name="txtAmount_5"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="date"
                id="txtLastuse_5"
                name="txtLastuse_5"
                className="add-only"
              />
            </td>
          </tr>
          <tr>
            <td className="w-150">
              Inhalants
              <span className="small">(LSD, PCP, mushrooms)</span>
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeFirstUse_6"
                name="txtAgeFirstUse_6"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeHeaviestUse_6"
                name="txtAgeHeaviestUse_6"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAmount_6"
                name="txtAmount_6"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="date"
                id="txtLastuse_6"
                name="txtLastuse_6"
                className="add-only"
              />
            </td>
          </tr>
          <tr>
            <td className="w-150">
              Opioids
              <span className="small">(Heroine, Narcotics, Methadone)</span>
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeFirstUse_7"
                name="txtAgeFirstUse_7"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeHeaviestUse_7"
                name="txtAgeHeaviestUse_7"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAmount_7"
                name="txtAmount_7"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="date"
                id="txtLastuse_7"
                name="txtLastuse_7"
                className="add-only"
              />
            </td>
          </tr>
          <tr>
            <td className="w-150">
              Sedative/Hypnotics
              <span className="small">(Valium, Xanax)</span>
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeFirstUse_8"
                name="txtAgeFirstUse_8"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeHeaviestUse_8"
                name="txtAgeHeaviestUse_8"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAmount_8"
                name="txtAmount_8"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="date"
                id="txtLastuse_8"
                name="txtLastuse_8"
                className="add-only"
              />
            </td>
          </tr>
          <tr>
            <td className="w-150">
              Designer Drugs
              <span className="small">(Herbal, Steroids, Cough Syrup)</span>
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeFirstUse_9"
                name="txtAgeFirstUse_9"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeHeaviestUse_9"
                name="txtAgeHeaviestUse_9"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAmount_9"
                name="txtAmount_9"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="date"
                id="txtLastuse_9"
                name="txtLastuse_9"
                className="add-only"
              />
            </td>
          </tr>
          <tr>
            <td className="w-150">Tobacco</td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeFirstUse_10"
                name="txtAgeFirstUse_10"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeHeaviestUse_10"
                name="txtAgeHeaviestUse_10"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAmount_10"
                name="txtAmount_10"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="date"
                id="txtLastuse_10"
                name="txtLastuse_10"
                className="add-only"
              />
            </td>
          </tr>
          <tr>
            <td className="w-150">Other</td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeFirstUse_11"
                name="txtAgeFirstUse_11"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAgeHeaviestUse_11"
                name="txtAgeHeaviestUse_11"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txtAmount_11"
                name="txtAmount_11"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="date"
                id="txtLastuse_11"
                name="txtLastuse_11"
                className="add-only"
              />
            </td>
          </tr>
        </table>
        <p>
          <span className="eleHeader">
            What consequences has the Individual faced as a result of the
            Drug/Alcohol use?
          </span>
          <span className="small">
            (Include hangovers, DT’s, Blackouts, Binges, Overdoses, Seizures, GI
            Bleeding, Job Loss, DUI’s, Assaults, Incarcerations, Homicides, etc)
          </span>
          <textarea
            id="txtConsequences"
            name="txtConsequences"
            className="add-only"
          ></textarea>
        </p>
        <table>
          <tr>
            <td className="w-375">
              <span className="eleHeader">Longest period of sobriety?</span>
            </td>
            <td className="w-375">
              <span className="eleHeader">When?</span>
            </td>
          </tr>
          <tr>
            <td className="w-375">
              <input
                type="text"
                id="txtLongestSobriety"
                name="txtLongestSobriety"
                className="add-only"
                required
              />
            </td>
            <td className="w-375">
              <input
                type="text"
                id="txtLongestSobrietyWhen"
                name="txtLongestSobrietyWhen"
                className="add-only"
                required
              />
            </td>
          </tr>
        </table>

        <h3> LEGAL HISTORY</h3>
        <table>
          <tr>
            <td className="w-375">
              <input
                type="checkbox"
                id="cbLegalHistory_1"
                name="cbLegalHistory_1"
                className="add-only"
                value="LegalHistory_1"
              />
              Probation Officer Contact and County:
            </td>
            <td className="w-375">
              <input
                type="checkbox"
                id="cbLegalHistory_2"
                name="cbLegalHistory_2"
                className="add-only"
                value="LegalHistory_2"
              />
              Parole Officer Contact and County:
            </td>
          </tr>
          <tr>
            <td className="w-375">
              <input
                type="text"
                id="txtLegalHistory_1"
                name="txtLegalHistory_1"
                className="add-only"
              />
            </td>
            <td className="w-375">
              <input
                type="text"
                id="txtLegalHistory_2"
                name="txtLegalHistory_2"
                className="add-only"
              />
            </td>
          </tr>
          <tr>
            <td className="w-375">
              <input
                type="checkbox"
                id="cbLegalHistory_3"
                name="cbLegalHistory_3"
                className="add-only"
                value="LegalHistory_3"
              />
              Number of Arrest in Past 30 Days:
            </td>
            <td className="w-375">
              <input
                type="checkbox"
                id="cbLegalHistory_4"
                name="cbLegalHistory_4"
                className="add-only"
                value="LegalHistory_4"
              />
              Number of arrests in the past year:
            </td>
          </tr>
          <tr>
            <td className="w-375">
              <input
                type="text"
                id="txtLegalHistory_3"
                name="txtLegalHistory_3"
                className="add-only"
              />
            </td>
            <td className="w-375">
              <input
                type="text"
                id="txtLegalHistory_4"
                name="txtLegalHistory_4"
                className="add-only"
              />
            </td>
          </tr>
          <tr>
            <td className="w-375">
              <input
                type="checkbox"
                id="cbLegalHistory_5"
                name="cbLegalHistory_5"
                className="add-only"
                value="LegalHistory_5"
              />
              Current Pending Charges:
            </td>
            <td className="w-375">
              <input
                type="checkbox"
                id="cbLegalHistory_6"
                name="cbLegalHistory_6"
                className="add-only"
                value="LegalHistory_6"
              />
              DFCS/CPS and County
            </td>
          </tr>
          <tr>
            <td className="w-375">
              <input
                type="text"
                id="txtLegalHistory_5"
                name="txtLegalHistory_5"
                className="add-only"
              />
            </td>
            <td className="w-375">
              <input
                type="text"
                id="txtLegalHistory_6"
                name="txtLegalHistory_6"
                className="add-only"
              />
            </td>
          </tr>
          <tr>
            <td className="w-375">
              <input
                type="checkbox"
                id="cbLegalHistory_7"
                name="cbLegalHistory_7"
                className="add-only"
                value="LegalHistory_7"
              />
              Restraining Order
            </td>
            <td className="w-375">
              <input
                type="checkbox"
                id="cbLegalHistory_8"
                name="cbLegalHistory_8"
                className="add-only"
                value="LegalHistory_8"
              />
              None
            </td>
          </tr>
          <tr>
            <td className="w-375">
              <input
                type="text"
                id="txtLegalHistory_7"
                name="txtLegalHistory_7"
                className="add-only"
              />
            </td>
            <td className="w-375">&nbsp;</td>
          </tr>
        </table>

        <p>
          <span className="eleHeader">PSYCHIATRIC STATUS: </span>

          <textarea
            id="txt_PSYCHIATRIC_STATUS"
            name="txt_PSYCHIATRIC_STATUS"
            className="add-only"
          ></textarea>
        </p>

        <p>
          <span className="eleHeader">PAIN ASSESSMENT</span>
          <span className="small">
            What current pain does the Individual have? (Include specific
            diagnosis, when problem was diagnosed, interventions) &nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <input
              type="checkbox"
              id="chk_PAIN_ASSESSMENT"
              name="chk_PAIN_ASSESSMENT"
              className="add-only"
              value="None"
            />
            None
          </span>

          <textarea
            id="txt_PAIN_ASSESSMENT"
            name="txt_PAIN_ASSESSMENT"
            className="add-only"
          ></textarea>
        </p>

        <p>
          <span className="eleHeader">PRESCRIBED PAIN MEDICATIONS </span>
          <span className="small">
            (Include both prescribed and over the counter medications taken for
            pain) &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <input
              type="checkbox"
              id="chk_PRESCRIBED_PAIN_MEDICATIONS"
              name="chk_PRESCRIBED_PAIN_MEDICATIONS"
              className="add-only"
              value="None"
            />
            None
          </span>
        </p>

        <table>
          <tr>
            <td className="w-170">
              <span className="eleHeader">Medication Name</span>
            </td>
            <td className="w-150">
              <span className="eleHeader">Dose/Frequency</span>
            </td>
            <td className="w-150">
              <span className="eleHeader">Prescribed by?</span>
            </td>
            <td className="w-100">
              <span className="eleHeader">When prescribed?</span>
            </td>
            <td className="w-100">
              <span className="eleHeader">When is next refill?</span>
            </td>
            <td className="w-100">
              <span className="eleHeader">Side Effects?</span>
            </td>
          </tr>
          <tr>
            <td className="w-170">
              <input
                type="text"
                id="txt_Medication_Name1"
                name="Medication_Name1"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txt_Dose_Frequency1"
                name="txt_Dose_Frequency1"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="date"
                id="txt_Prescribed_by1"
                name="txt_Prescribed_by1"
                className="add-only"
              />
            </td>
            <td className="w-100">
              <input
                type="text"
                id="txt_When_prescribed1"
                name="txt_When_prescribed1"
                className="add-only"
              />
            </td>
            <td className="w-100">
              <input
                type="text"
                id="txt_When_is_next_refill1"
                name="txt_When_is_next_refill1"
                className="add-only"
              />
            </td>
            <td className="w-100">
              <input
                type="text"
                id="txtAge_Side_Effects1"
                name="txtAge_Side_Effects1"
                className="add-only"
              />
            </td>
          </tr>

          <tr>
            <td className="w-170">
              <input
                type="text"
                id="txt_Medication_Name2"
                name="Medication_Name2"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="text"
                id="txt_Dose_Frequency2"
                name="txt_Dose_Frequency2"
                className="add-only"
              />
            </td>
            <td className="w-150">
              <input
                type="date"
                id="txt_Prescribed_by2"
                name="txt_Prescribed_by2"
                className="add-only"
              />
            </td>
            <td className="w-100">
              <input
                type="text"
                id="txt_When_prescribed2"
                name="txt_When_prescribed2"
                className="add-only"
              />
            </td>
            <td className="w-100">
              <input
                type="text"
                id="txt_When_is_next_refill2"
                name="txt_When_is_next_refill2"
                className="add-only"
              />
            </td>
            <td className="w-100">
              <input
                type="text"
                id="txtAge_Side_Effects2"
                name="txtAge_Side_Effects2"
                className="add-only"
              />
            </td>
          </tr>
        </table>

        <table>
          <tr>
            <td className="w-750">
              <span className="eleHeader">
                Is Individual compliant with medications?{" "}
              </span>
            </td>
          </tr>
          <tr>
            <td className="w-150">
              <input
                type="radio"
                id="rb_compliant_medications_yes"
                name="compliant_Medications"
                className="add-only"
                value="Yes"
              />{" "}
              Yes &nbsp; &nbsp;
              <input
                type="radio"
                id="rb_compliant_medications_No"
                name="compliant_Medications"
                className="add-only"
                value="No"
              />{" "}
              No, explain:
            </td>

            <td>
              <input
                type="text"
                id="txt_compliant_medications_No"
                name="txt_compliant_medications_No"
                className="add-only"
              />
            </td>
          </tr>
        </table>

        <table>
          <tr>
            <td className="w-750">
              <span className="eleHeader">
                Current Physician Prescribing Medication(s) for{" "}
              </span>
            </td>
          </tr>
          <tr>
            <td className="w-350">
              <span className="eleHeader">Pain:</span>
            </td>
            <td className="w-350">
              <span className="eleHeader">Telephone No.</span>
            </td>
          </tr>
          <tr>
            <td className="w-350">
              <input
                type="text"
                id="txtPain"
                name="txtPain"
                className="add-only"
              />
            </td>
            <td className="w-350">
              <input
                type="text"
                id="txtTelephone"
                name="txtTelephone"
                className="add-only"
              />
            </td>
          </tr>
        </table>
        <br />
        <br />

        <h2>COLUMBIA-SUICIDE SEVERITY RATING SCALE</h2>

        <table>
          <tr>
            <th className="w-600" colspan="2">
              SUICIDE IDEATION DEFINITIONS AND PROMPTS:
            </th>
            <th className="w-150">Past month </th>
          </tr>

          <tr>
            <td className="w-600">
              <span className="eleHeader">
                Ask questions that are bolded and underlined.
              </span>
            </td>
            <td className="w-75">
              <span className="eleHeader">Yes</span>
            </td>
            <td className="w-75">
              <span className="eleHeader">No</span>
            </td>
          </tr>

          <tr>
            <td>
              <h2>Ask Questions 1 and 2 :</h2>
            </td>
          </tr>
          <br />
          {/*==== ===================================================================================================================================================        */}
          <tr>
            <td className="w-600">
              <strong> 1) Wish to be Dead: </strong>
              <span className="small">
                Person endorses thoughts about a wish to be dead or not alive
                anymore, or wish to fall asleep and not wake up.
              </span>
            </td>
          </tr>
          <tr>
            <td className="w-600">
              <u>
                <strong>
                  Have you wished you were dead or wished you could go to sleep
                  and not wake up?{" "}
                </strong>
              </u>{" "}
            </td>
            <td className="w-20"></td>
            <td className="w-75">
              {" "}
              <input
                type="radio"
                id="rb_Wish_Dead_yes"
                name="Wish_Dead"
                className="add-only"
                value="Yes"
              />
            </td>
            <td className="w-75">
              <input
                type="radio"
                id="rb_Wish_Dead_No"
                name="Wish_Dead"
                className="add-only"
                value="No"
              />
            </td>
          </tr>

          <br />
          <br />
          {/* ================================================================================================================ */}
          <tr>
            <td className="w-600">
              <strong> 2) Suicidal Thoughts: </strong>
              <span className="small">
                General non-specific thoughts of wanting to end one’s
                life/commit suicide, “I’ve thought about killing myself” without
                general thoughts of ways to kill oneself/associated methods,
                intent, or plan.”
              </span>
            </td>
          </tr>
          <tr>
            <td className="w-600">
              <u>
                <strong>
                  Have you actually had any thoughts of killing yourself?{" "}
                </strong>
              </u>{" "}
            </td>
            <td className="w-20"></td>
            <td className="w-75">
              {" "}
              <input
                type="radio"
                id="rb_Suicidal_Thoughtyes"
                name="Suicidal_Thoughts"
                className="add-only"
                value="Yes"
              />
            </td>
            <td className="w-75">
              <input
                type="radio"
                id="rb_Suicidal_ThoughtNo"
                name="Suicidal_Thoughts"
                className="add-only"
                value="No"
              />
            </td>
          </tr>

          <br />
          <br />
          {/* ======================================================================================================================================== */}

          <tr>
            <td className="w-600">
              <h2>
                If YES to 2, ask questions 3, 4, 5, and 6. If NO to 2, go
                directly to question 6.{" "}
              </h2>
            </td>
          </tr>
          <br />

          <tr>
            <td className="w-600">
              <strong>
                {" "}
                3) Suicidal Thoughts with Method (without Specific Plan or
                Intent to Act):{" "}
              </strong>
              <span className="small">
                Person endorses thoughts of suicide and has thought of a least
                one method during the assessment period. This is different than
                a specific plan with time, place or method details worked out.
                “I thought about taking an overdose but I never made a specific
                plan as to when where or how I would actually do it….and I would
                never go through with it.”
              </span>
            </td>
          </tr>
          <tr>
            <td className="w-600">
              <u>
                <strong>
                  Have you been thinking about how you might kill yourself?{" "}
                </strong>
              </u>{" "}
            </td>
            <td className="w-20"></td>
            <td className="w-75">
              {" "}
              <input
                type="radio"
                id="rb_Suicidal_Thought_Methodyes"
                name="Suicidal_Thought_Method"
                className="add-only"
                value="Yes"
              />
            </td>
            <td className="w-75">
              <input
                type="radio"
                id="rb_Suicidal_Thought_MethodNo"
                name="Suicidal_Thought_Method"
                className="add-only"
                value="No"
              />
            </td>
          </tr>

          <br />
          <br />
          {/* =============================================================================================================================================== */}

          <tr>
            <td className="w-600">
              <strong> 4) Suicidal Intent (without Specific Plan): </strong>
              <span className="small">
                Active suicidal thoughts of killing oneself and patient reports
                having some intent to act on such thoughts, as opposed to “I
                have the thoughts but I definitely will not do anything about
                them.”
              </span>
            </td>
          </tr>
          <tr>
            <td className="w-600">
              <u>
                <strong>
                  Have you had these thoughts and had some intention of acting
                  on them?{" "}
                </strong>
              </u>{" "}
            </td>
            <td className="w-20"></td>
            <td className="w-75">
              {" "}
              <input
                type="radio"
                id="rb_Suicidal_Intent1yes"
                name="Suicidal_Intent1"
                className="add-only"
                value="Yes"
              />
            </td>
            <td className="w-75">
              <input
                type="radio"
                id="rb_Suicidal_Intent1No"
                name="Suicidal_Intent1"
                className="add-only"
                value="No"
              />
            </td>
          </tr>

          <br />
          <br />

          {/* =========================================================================================================================================== */}

          <tr>
            <td className="w-600">
              <strong> 5) Suicide Intent (with Specific Plan): </strong>
              <span className="small">
                Thoughts of killing oneself with details of plan fully or
                partially worked out and person has some intent to carry it out.
              </span>
            </td>
          </tr>
          <tr>
            <td className="w-600">
              <u>
                <strong>
                  Have you started to work out or worked out the details of how
                  to kill yourself? Do you intend to carry out this plan?{" "}
                </strong>
              </u>{" "}
            </td>
            <td className="w-20"></td>
            <td className="w-75">
              {" "}
              <input
                type="radio"
                id="rb_Suicidal_Intent2yes"
                name="Suicidal_Intent2"
                className="add-only"
                value="Yes"
              />
            </td>
            <td className="w-75">
              <input
                type="radio"
                id="rb_Suicidal_Intent2No"
                name="Suicidal_Intent2"
                className="add-only"
                value="No"
              />
            </td>
          </tr>

          <br />
          <br />

          {/* =============================================================================================================================================== */}

          <tr>
            <td>
              <strong className="w-600"> 6) Suicide Behavior Question :</strong>
            </td>
          </tr>
          <tr>
            <td className="w-600">
              <u>
                <strong>
                  {" "}
                  Have you ever done anything, started to do anything, or
                  prepared to do anything to end your life?”{" "}
                </strong>
              </u>
            </td>

            <td className="w-20"></td>

            <td className="w-75">
              <input
                type="radio"
                id="rb_Suicidal_Intent2yes"
                name="Suicidal_Intent2"
                className="add-only"
                value="Yes"
              />{" "}
            </td>
            <td className="w-75">
              <input
                type="radio"
                id="rb_Suicidal_Intent2No"
                name="Suicidal_Intent2"
                className="add-only"
                value="No"
              />
            </td>
          </tr>
          <tr>
            <td className="w-500">
              <span className="small">
                Examples: Collected pills, obtained a gun, gave away valuables,
                wrote a will or suicide note, took out pills but didn’t swallow
                any, held a gun but changed your mind or it was grabbed from
                your hand, went to the roof but didn’t jump; or actually took
                pills, tried to shoot yourself, cut yourself, tried to hang
                yourself, etc.
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <strong className="w-550">
                If YES, ask: How long ago did you do any of these?{" "}
              </strong>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                {" "}
                ・ Over a year ago? ・ Between three months and a year ago? ・
                Within the last three months?{" "}
              </p>
            </td>
          </tr>
        </table>
        <br />

        <p>
          <span className="eleHeader">EMPLOYMENT/SUPPORT STATUS</span>

          <textarea
            id="txt_EMPLOYMENT_SUPPORT_STATUS"
            name="txt_EMPLOYMENT_SUPPORT_STATUS"
            className="add-only"
          ></textarea>
        </p>
        <br />

        <p>
          <span className="eleHeader">FAMILY/SOCIAL HISTORY:</span>

          <textarea
            id="txt_FAMILY_SOCIAL_HISTORY"
            name="txt_FAMILY_SOCIAL_HISTORY"
            className="add-only"
          ></textarea>
        </p>
        <br />

        <p>
          <span className="eleHeader">SASSI DIAGNOSTIC IMPRESSION:</span>

          <textarea
            id="txt_SASSI_DIAGNOSTIC"
            name="txt_SASSI_DIAGNOSTIC"
            className="add-only"
          ></textarea>
        </p>
        <br />

        <p>
          <span className="eleHeader">
            DSM-5/ ICD-10 DIAGNOSTIC IMPRESSION:
          </span>

          <textarea
            id="txt_DIAGNOSTIC_IMPRESSION"
            name="txt_DIAGNOSTIC_IMPRESSION"
            className="add-only"
          ></textarea>
        </p>
        <br />

        <table>
          <tr>
            <td className="w-750">
              <span className="eleHeader">
                Diagnostic Category (Both Primary and Secondary categories as
                required) – Co-Occurring Disorders Present?:{" "}
              </span>
            </td>
          </tr>
          <tr>
            <strong className="w-150"> Primary:</strong>
            <td>
              <input
                type="checkbox"
                id="cbPrimary1"
                name="cbPrimary1"
                className="add-only"
                value="Primary1"
              />
              Adult MH&nbsp; &nbsp;
              <input
                type="checkbox"
                id="cbPrimary2"
                name="cbPrimary2"
                className="add-only"
                value="Primary2"
              />
              Adult SA&nbsp; &nbsp;
              <input
                type="checkbox"
                id="cbPrimary3"
                name="cbPrimary3"
                className="add-only"
                value="Primary3"
              />
              Adult DD
            </td>
          </tr>
          <br />

          <tr>
            <strong className="w-150"> Secondary:</strong>
            <td>
              <input
                type="checkbox"
                id="cbSecondary0"
                name="cbSecondary0"
                className="add-only"
                value="Secondary0"
              />
              None&nbsp; &nbsp;
              <input
                type="checkbox"
                id="cbSecondary1"
                name="cbSecondary1"
                className="add-only"
                value="Secondary1"
              />
              Adult MH&nbsp; &nbsp;
              <input
                type="checkbox"
                id="cbSecondary2"
                name="cbSecondary2"
                className="add-only"
                value="Secondary2"
              />
              Adult SA&nbsp; &nbsp;
              <input
                type="checkbox"
                id="cbSecondary3"
                name="cbSecondary3"
                className="add-only"
                value="Secondary3"
              />
              Adult DD
            </td>
          </tr>
        </table>

        <p>
          <span className="eleHeader">INTERPRETIVE SUMMARY</span>

          <textarea
            id="txt_INTERPRETIVE_SUMMARY"
            name="txt_INTERPRETIVE_SUMMARY"
            className="add-only"
          ></textarea>
        </p>

        <p>
          <span className="eleHeader">RECOMMENDATION FOR TREATMENT</span>
          <strong>Care Level Recommendations: </strong>
          <br />

          <textarea
            id="txt_RECOMMENDATION_TREATMENT"
            name="txt_RECOMMENDATION_TREATMENT"
            className="add-only"
          ></textarea>
        </p>

        <h3>COMPLETED BY:</h3>
        <p>
          <span className="small">
            (Please include credentials after your name)
          </span>
        </p>
        <table>
          <tr>
            <td className="w-375 signature">&nbsp;</td>
            <td className="w-375 signature">&nbsp;</td>
          </tr>
          <tr>
            <td className="w-375 small">Assessor Signature:</td>
            <td className="w-375 small">Date:</td>
          </tr>
          <tr>
            <td className="w-375 signature">&nbsp;</td>
            <td className="w-375 signature">&nbsp;</td>
          </tr>
          <tr>
            <td className="w-375 small">Assessor Print Name:</td>
            <td className="w-375 small">Date:</td>
          </tr>
        </table>
        <h3>REVIEWED BY </h3>
        <span className="small">(If Applicable):</span>
        <p>
          <span className="small">
            (Please include credentials after your name)
          </span>
        </p>
        <table>
          <tr>
            <td className="w-375 signature">&nbsp;</td>
            <td className="w-375 signature">&nbsp;</td>
          </tr>
          <tr>
            <td className="w-375 small">Licensed Professional Signature:</td>
            <td className="w-375 small">Date:</td>
          </tr>
          <tr>
            <td className="w-375 signature">&nbsp;</td>
            <td className="w-375 signature">&nbsp;</td>
          </tr>
          <tr>
            <td className="w-375 small">Licensed Professional Print Name:</td>
            <td className="w-375 small">Date:</td>
          </tr>
        </table>
      </div>
    </form>
  );
};
